import React, { ReactNode, useMemo } from 'react';

import { UiComponent } from 'components';
import { tableWrap } from 'styles/table';
import { IPageOption, IUserListItem } from 'types';
import { useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';
import { getUserStatus } from '../utils/status';
import { BiPencil } from 'react-icons/bi';

const COLS: string[] = [
  '회원번호',
  '이름',
  '휴대폰',
  // '생년월일',
  '계정상태',
  '가입일',
];

interface Props {
  pageOption: IPageOption;
  handlePage: (option: IPageOption) => void;
  data: IUserListItem[];
  totalPage: number;
  toolbar?: ReactNode;
}

function List({ data, toolbar, ...pageOptions }: Props) {
  const navigate = useNavigate();

  const renderer: Record<
    (typeof COLS)[number],
    (data: IUserListItem & { row: number }) => ReactNode
  > = useMemo(
    () => ({
      회원번호: ({ id }: IUserListItem) => <>{id}</>,
      이름: ({ id, name }: IUserListItem) => (
        <p
          css={{ textDecoration: 'underline', cursor: 'pointer' }}
          title="회원 상세 정보 수정"
          onClick={() => navigate(`/users/${id}`)}
        >
          {name}
          <span css={{ marginLeft: '4px' }}>
            <BiPencil size={11} />
          </span>
        </p>
      ),
      휴대폰: ({ phone }: IUserListItem) => <>{phone}</>,
      // 생년월일: ({ birthDate }: IUserListItem) => <>{birthDate}</>,
      계정상태: ({ status }: IUserListItem) => <>{getUserStatus(status)}</>,
      가입일: ({ signUpDate }: IUserListItem) => (
        <>{dayjs(signUpDate).format('YYYY-MM-DD')}</>
      ),
    }),
    [],
  );

  return (
    <UiComponent.Box>
      {toolbar}
      <div css={tableWrap}>
        <UiComponent.Table cols={COLS} renderer={renderer} data={data} sticky />
      </div>
      <UiComponent.Pagination {...pageOptions} />
    </UiComponent.Box>
  );
}

export default List;
